<script>
	import { fade } from 'svelte/transition';
    import { fly } from 'svelte/transition';
</script>

<div class="" in:fly="{{ y: 400, duration: 1200 }}" >
	<slot></slot>
</div>